export default __webpack_public_path__ + "static/media/corner-shewolf.827d9d91.webp";